import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from '@app/services/authentication.service';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private _router: Router,
    private _authService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this._authService.accessToken;

    const modified = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${authToken}`)
    });

    const handler: Observable<HttpEvent<any>> = authToken && this._authService.isLoggedIn
      ? next.handle(modified)
      : next.handle(request);

    return handler
      .pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              this._authService.logout();
              this._router.navigate(['/login']);
            }
          }
          return throwError(error);
        })
      );
  }
}

